import React from "react"
import { Modal, Button } from "antd"
import { Title, Text } from "ui/Typography"
import { Icon } from "ui/Icon"
import { colors } from "themes/variables"
import styles from "./ConfirmModal.module.css"
import PropTypes from "prop-types"

const ConfirmModal = ({
  open,
  title,
  info,
  onCancel,
  onOk,
  onExit,
  onDelete,
  exitLabel = "Leave without saving",
  cancelLabel = "Cancel",
  okLabel = "Save",
  deleteLabel = "Delete",
  hideCancelButton,
  zIndex
}) => {
  return (
    <Modal
      centered
      zIndex={zIndex}
      className={styles.confirmModal}
      title={
        <div className="justify-center">
          <div className={styles.circleWrapper}>
            <Icon name="confirmDisclaimer" color={colors.error} />
          </div>
        </div>
      }
      open={open}
      footer={[
        onExit && (
          <Button key="exit" color="danger" variant="outlined" size="large" className="px-xl" onClick={onExit}>
            {exitLabel}
          </Button>
        ),
        !hideCancelButton && (
          <Button key="cancel" color="primary" variant="outlined" size="large" className="px-xl" onClick={onCancel}>
            {cancelLabel}
          </Button>
        ),
        onOk && (
          <Button key="save" type="primary" size="large" className="px-xl" onClick={onOk}>
            {okLabel}
          </Button>
        ),
        onDelete && (
          <Button key="delete" color="danger" variant="solid" size="large" className="px-xl" onClick={onDelete}>
            {deleteLabel}
          </Button>
        )
      ]}
      onCancel={onCancel}
      maskClosable={false}
      width={460}
    >
      <div>
        {(info || title) && (
          <>
            {title && <Title level={3} className="mb-m">{title}</Title>}
            {info && (
              <Text type="body">
                <div dangerouslySetInnerHTML={{ __html: info }} />
              </Text>
            )}
          </>
        )}
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  info: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  onExit: PropTypes.func,
  onDelete: PropTypes.func,
  exitLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  okLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  hideCancelButton: PropTypes.bool,
  zIndex: PropTypes.number
}

export { ConfirmModal }
